import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-email-tagfield',
  templateUrl: './email-tagfield.component.html',
  styleUrl: './email-tagfield.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EmailTagfieldComponent {
  constructor(
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @ViewChild('emailEditDiv') EmailEditDiv?: ElementRef;

  @Input() Emails: string[] = [];
  EmailModel: { email: string } = { email: '' };

  @Output() addedEmail = new EventEmitter<string>();
  @Output() removedEmail = new EventEmitter<string>();

  // Traditional data binding to textArea on div element is buggy.
  // This works around it.
  removeEmailFromElementAndModel() {
    (this.EmailEditDiv?.nativeElement as HTMLDivElement).textContent = '';
    Object.assign(this.EmailModel, { email: '' });
  }

  removeEmail(email: string, index: number) {
    this.Emails.splice(index, 1);
    this.removedEmail.emit(this.Emails.join(';'));
  }

  addEmail(KeydownEvent: KeyboardEvent) {
    const { email } = this.EmailModel;
    const { key } = KeydownEvent;

    if (key === 'Enter' && email) {
      const isValid = this.UtilityService.getRegex('email').test(email);

      if (!isValid) {
        throw this.ToastService.addErrorToast(
          'Error',
          'Email is not formatted properly.',
          { returnError: true }
        );
      }

      this.Emails.push(email);
      this.removeEmailFromElementAndModel();
      this.addedEmail.emit(this.Emails.join(';'));
      KeydownEvent.preventDefault();
    }
  }

  // When user clicks out of focus of the element, we will add the email if it's valid.
  blurAddEmail() {
    const { email } = this.EmailModel;

    if (email) {
      const isValid = this.UtilityService.getRegex('email').test(email);

      if (isValid) {
        this.Emails.push(email);
        this.addedEmail.emit(this.Emails.join(';'));
      }

      this.removeEmailFromElementAndModel();
    }
  }

  emailChange(event: Event) {
    this.EmailModel.email = (event.target as HTMLDivElement).textContent || '';
  }
}
